import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getSettings, getBrands } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { CompanyCard } from "@/components/site/CompanyCard";

export default function Companies() {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const { data: brands = [], isLoading } = useQuery({ queryKey: ["brands"], queryFn: getBrands });

  return (
    <>
      <Seo title="Our Companies" path="/companies" settings={settings}
        description="The operating companies of Acharya Holdings — independent brands across infrastructure, consumer products, public initiatives, and media, supported by shared governance and long-term intent."
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Our Companies", path: "/companies" }]} />
      <PageIntro eyebrow="Our Companies" title="Independent brands. Shared standards."
        description="Each company operates with its own mandate and identity, supported by common governance, disciplined capital, and a shared commitment to long-term value creation." />
      <section className="container-inst py-16 lg:py-24">
        {isLoading ? (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-64 animate-pulse rounded-[18px]" style={{ background: "var(--surface)", border: "1px solid var(--card-border)" }} />)}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {brands.map((b) => <CompanyCard key={b.id} brand={b} />)}
          </div>
        )}
      </section>
    </>
  );
}
